import React, { useState, useEffect } from 'react'; // Import useState and useEffect
import { Row, Col, Button, Form, Dropdown, ButtonGroup } from 'react-bootstrap';
import { MdDateRange, MdAddchart } from 'react-icons/md';
import { Link } from 'react-router-dom'; // Import Link for navigation
import './apply-leave.css'; // Import the CSS file for styles
import LeaveLayout from '../../components/LeaveLayout.js';

// Number of rows per page
const rowsPerPage = 10;

// Dummy data
const mockLeaveData = Array.from({ length: 50 }, (_, index) => ({
  id: index + 1,
  leaveType: `Leave Type ${index + 1}`,
  days: Math.floor(Math.random() * 10) + 1, // Random number of days
  description: `Description ${index + 1}`,
}));

export default function ApplyLeave() {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      const startIndex = (currentPage - 1) * rowsPerPage;
      const endIndex = startIndex + rowsPerPage;
      setData(mockLeaveData.slice(startIndex, endIndex));
      setLoading(false);
    }, 500); // Simulate a 0.5-second delay
  }, [currentPage]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(mockLeaveData.length / rowsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };

  const pageRange = () => {
    const pages = [];
    const totalPages = Math.ceil(mockLeaveData.length / rowsPerPage);
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);

    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <LeaveLayout>
      <div>
        <h1 style={{ color: '#0353a4', textAlign: 'left', fontSize: '2rem',marginTop:'10px' }}>
          <MdDateRange /> Total Leaves
        </h1>
        <hr className="apply-divider" />
        <div className='apply-leave-content'>
          <Link to="/add-leave">
            <Button variant='primary' className='apply-leave-button mb-2'>
              <MdAddchart className="button-icon" /> Apply Leave
            </Button>
          </Link>
          <div className='apply-leave-actions'>
            <Row>
              <Col xs={12} md={6} className="d-flex align-items-center">
                <Dropdown as={ButtonGroup}>
                  <Button variant="primary">Show Entries</Button>
                  <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" />
                  <Dropdown.Menu>
                    <Dropdown.Item href="#/action-1">10</Dropdown.Item>
                    <Dropdown.Item href="#/action-2">25</Dropdown.Item>
                    <Dropdown.Item href="#/action-3">50</Dropdown.Item>
                    <Dropdown.Item href="#/action-4">100</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Col>
              <Col xs={12} md={6} className="d-flex justify-content-end">
                <div className='search-container'>
                  <Form className="d-flex">
                    <Form.Control
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                      className="apply-leave-search"
                    />
                  </Form>
                </div>
              </Col>
            </Row>
          </div>
          <div className="table-responsive">
            <table className='table table-striped table-style'>
              <thead className="apply-leave-table-header">
                <tr className="table-header-footer">
                  <th>SR</th>
                  <th>Leave Type</th>
                  <th>Days</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan="4" className="text-center">Loading...</td></tr>
                ) : (
                  data.map(item => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.leaveType}</td>
                      <td>{item.days}</td>
                      <td>{item.description}</td>
                    </tr>
                  ))
                )}
              </tbody>
              <tfoot>
              <tr className='apply-leave-table-footer'>
                <td>Total</td>
                <td>-</td>
                <td>0</td>
                <td></td>
              </tr>
            </tfoot>
            </table>
            <div className="pagination-container">
              <Row className="custom-row">
                <Col xs={12} md={9} className="custom-col-left">
                  Showing {(currentPage - 1) * rowsPerPage + 1} to {Math.min(currentPage * rowsPerPage, mockLeaveData.length)} of {mockLeaveData.length} Entries
                </Col>
                <Col xs={12} md={3} className="custom-col-right">
                  <nav>
                    <ul className="pagination">
                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <a
                          href="/#"
                          className="page-link"
                          onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(currentPage - 1);
                          }}
                        >
                          Previous
                        </a>
                      </li>
                      {pageRange().map(pageNumber => (
                        <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                          <a
                            href="/#"
                            className="page-link"
                            onClick={(e) => {
                              e.preventDefault();
                              handlePageChange(pageNumber);
                            }}
                          >
                            {pageNumber}
                          </a>
                        </li>
                      ))}
                      <li className={`page-item ${currentPage === Math.ceil(mockLeaveData.length / rowsPerPage) ? 'disabled' : ''}`}>
                        <a
                          href="/#"
                          className="page-link"
                          onClick={(e) => {
                            e.preventDefault();
                            handlePageChange(currentPage + 1);
                          }}
                        >
                          Next
                        </a>
                      </li>
                    </ul>
                  </nav>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </LeaveLayout>
  );
}
